import {ArchitectElement, ArchitectElControl, ElementControlType} from '../architect-element';
import {mutationState} from '@app/editor/state/mutation-store';
import {ModifyAttributes} from '@app/editor/mutations/attributes/modify-attributes';
import {setSelectedContext} from '@app/editor/state/set-selected-context';
import {getNodeId} from '@app/editor/utils/get-node-id';
import {addIdToNode} from '@app/editor/utils/add-id-to-node';
import {editorState} from '@app/editor/state/editor-store';
import {inspectorState} from '@app/editor/state/inspector-store';

export class FactoryEl extends ArchitectElement {
  name = 'Rhumba AI Article';
  contentCategories = ['flow'];
  allowedContent = ['flow'];
  category = 'addons';
  specificity = 10;
  canDrag = true;
  resizable = false;
  
  editActions = [
    {
      name: 'Refresh Article',
      action: (node: HTMLElement) => {
        try {
          const doc = node.ownerDocument;
          const parent = node.parentNode;
          
          if (!parent) return;
          
          // Store all widget attributes
          const attrs: Record<string, string> = {
            'data-sdk': 'factory',
            'data-article-id': node.getAttribute('data-article-id') || '',
            'data-article-url': node.getAttribute('data-article-url') || '',
            'data-article-keyword': node.getAttribute('data-article-keyword') || '',
          };
          
          // Store tracking info
          const style = node.getAttribute('style');
          
          // Clear ALL references to the old node before replacing
          editorState().setSelectedContext(null);
          inspectorState().reset();
          
          // Create new article container
          const newArticle = doc.createElement('article');
          
          // Apply all current attributes to new article
          Object.entries(attrs).forEach(([key, value]) => {
            if (value) {
              newArticle.setAttribute(key, value);
            }
          });
          
          // Give it a new node ID
          addIdToNode(newArticle, true);
          
          // Store the new node ID for reselection
          const newNodeId = getNodeId(newArticle);
          
          // Preserve styling
          if (style) {
            newArticle.setAttribute('style', style);
          }
          
          // Preserve inner content
          newArticle.innerHTML = node.innerHTML;
          
          // Replace the old node with new article
          parent.replaceChild(newArticle, node);
          
          // Auto-reselect the new article
          setTimeout(() => {
            if (newNodeId) {
              setSelectedContext(newNodeId, {force: true});
            }
          }, 100);
        } catch (error) {
          console.error('Error refreshing Factory article:', error);
        }
      },
    },
  ];
  
  controls = [
    new ArchitectElControl({
      label: 'Article ID',
      type: ElementControlType.Input,
      defaultValue(node: HTMLElement) {
        return node.getAttribute('data-article-id') ?? '';
      },
      onChange(node: HTMLElement, value: string, options) {
        mutationState().executeMutation(
          new ModifyAttributes(node, {
            'data-article-id': value || '',
          }),
          options,
        );
      },
    }),
    new ArchitectElControl({
      label: 'Article Keyword',
      type: ElementControlType.Input,
      defaultValue(node: HTMLElement) {
        return node.getAttribute('data-article-keyword') ?? '';
      },
      onChange(node: HTMLElement, value: string, options) {
        mutationState().executeMutation(
          new ModifyAttributes(node, {
            'data-article-keyword': value,
          }),
          options,
        );
      },
    }),
    new ArchitectElControl({
      label: 'Article URL',
      type: ElementControlType.Input,
      defaultValue(node: HTMLElement) {
        return node.getAttribute('data-article-url') ?? '';
      },
      onChange(node: HTMLElement, value: string, options) {
        mutationState().executeMutation(
          new ModifyAttributes(node, {
            'data-article-url': value,
          }),
          options,
        );
      },
    }),
  ];
  
  matcher(node: HTMLElement) {
    return node.getAttribute('data-sdk') === 'factory';
  }
}

